<template>
  <ul class="sidebar-version-list">
    <li>
      <el-link v-if="sidebar.opened" :href="releaseNotesUrl" target="_blank" class="sidebar-version el-menu-item">
        BE: {{ getAPIVersion }}
      </el-link>
    </li>
    <li>
      <el-link v-if="sidebar.opened" :href="releaseNotesUrl" target="_blank" class="sidebar-version el-menu-item">
        UI: {{ getUIVersion }}
      </el-link>
    </li>
  </ul>
</template>
<script>
import { mapGetters } from 'vuex'

import { releaseNotesUrl } from '@/application.constants'
import i18n from '@/lang/index'
import { formatDateToAppVersionFormat } from '@/utils/date'

export default {
  name: 'AppVersion',
  data() {
    return {
      releaseNotesUrl
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'version']),
    getAPIVersion() {
      if (!this.version) {
        return ''
      }

      const dateTimeParts = 5
      const versionLabel = i18n.global.t('navbar.version')
      const parts = this.version.split('-')
      const dateTime = parts.slice(0, dateTimeParts).join('-')
      const hash = parts[dateTimeParts]

      return `${dateTime} ${versionLabel}: ${hash}`
    },
    getUIVersion() {
      if (!import.meta.env.VITE_APP_VERSION && !import.meta.env.VITE_APP_COMMIT_HASH) {
        return ''
      }

      const versionLabel = i18n.global.t('navbar.version')
      const buildVersion = import.meta.env.VITE_APP_VERSION

      if (!import.meta.env.VITE_APP_COMMIT_DATE || !import.meta.env.VITE_APP_COMMIT_HASH) {
        return `${versionLabel}: ${buildVersion}`
      }

      const formattedDate = formatDateToAppVersionFormat(new Date(import.meta.env.VITE_APP_COMMIT_DATE))

      return `${versionLabel}: ${buildVersion} (${formattedDate} ${import.meta.env.VITE_APP_COMMIT_HASH})`
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.sidebar-version-list {
  padding-inline-start: 0;
  list-style-type: none;
}

.sidebar-version {
  line-height: normal;

  &:hover,
  &:focus {
    background: rgb(38, 52, 69);
    color: #bfcbd9;

    &:after {
      border: none;
    }
  }
}
</style>
